import { Outlet, createFileRoute } from '@tanstack/react-router';
import { SalesAreaGate } from '@/components/billing/SalesAreaGate';

function CrmAreaLayout() {
	return (
		<SalesAreaGate>
			<Outlet />
		</SalesAreaGate>
	);
}

export const Route = createFileRoute('/_authenticated/_app/crm')({
	component: CrmAreaLayout,
});
